import React, { useState, useEffect } from 'react';
import { IoIosCheckmarkCircle, IoIosCloseCircle } from 'react-icons/io';
import { UncontrolledTooltip, Row, Col } from 'reactstrap';
import { TrafficLightTooltip } from './assets'
import Lang from 'Lang/General'
import _ from 'lodash';

const TrafficLightComponent = (props) => {
  const { row } = props;
  const [tooltips, setTooltips] = useState([]);

  useEffect(() => {
    const newTooltips = [];
  
    row.original?.fairs?.[0] &&
    row.original.fairs.forEach( fair => {
      _.keys(fair.traffic_light).forEach((key) => {
        newTooltips.push(`${key}_${row.original.id}_${fair.id}`);
      });
    })
    setTooltips(newTooltips);
  }, [row]);


  return (
    <Row style={{ margin: 'auto' }}>
      {row.original?.fairs?.[0] &&
        row.original.fairs.map((fair) => (
          <Col lg={12} className="d-flex justify-content-center" style={{ gap: 3 }} key={fair.id}>
            {_.keys(fair.traffic_light).map((key) => {
              const targetId = `${key}_${row.original.id}_${fair.id}`;
              return (
                <React.Fragment key={targetId}>
                  <div id={targetId}>
                    {fair.traffic_light[key] ? (
                      <IoIosCheckmarkCircle
                        size={20}
                        className="mr-1 text-success"
                      />
                    ) : (
                      <IoIosCloseCircle
                        size={20}
                        className="mr-1 text-danger"
                      />
                    )}
                  </div>
                  {tooltips.includes(targetId) && (
                    <UncontrolledTooltip
                      target={targetId}
                      placement="top"
                    >
                      {Lang[TrafficLightTooltip[key]][
                        props.data.languageReducer.userSettings.admin_panel_language
                      ]}
                      {` - ${fair.title}`}
                    </UncontrolledTooltip>
                  )}
                </React.Fragment>
              );
            })}
          </Col>
        ))}
    </Row>
  );
};

export default TrafficLightComponent;
